import { createMachine, assign } from "xstate";

function createBookingBarMachine(initialContext) {
  const bookingBarMachine = createMachine(
    {
      /** @xstate-layout N4IgpgJg5mDOIC5QCMD2qDWBLAdlAQgIYBOAdFhADZgDEAogCICSAKgNoAMAuoqAA6pYWAC5ZUOXiAAeiAEwBGABykOAFnkA2DaoCcO2ToDMq9QBoQAT0QbF80jo3zZi52oCsHYwF8v5tJlwCEnIqWjoAWQAFFgBNAH0AZQBVfHDWTh4kEAEhUXFJGQRVWXMrBDdbUkM3BwB2Dg55eVVDWp8-dGw8IjJIEUCaBLoWOIAZAHkAYQBBFiZxgDkMyRz+-KzCw0MNUnl9WpNFDlqdYvlSxDdHeyNVDQ4r5u0ddpB-LqDeiH68QeG46aTSbjcLhcYMWbzJbcFaCNYSDaIQx7Uh3DgOCryNzqEqWRB3NykRQ6JSKNy1DzbCmvd6BHqkPqiX4AJToQxGgOBoPBkMWyyyqzyCNAm3kHBUslU6Ml6Lcsg0sjcFwQ2x0pBOnjFRn2DQ0NM6dOCjIG7LiEJYdH5-DhQoKSI0hK0bkMOiOqjce08ytktUMpBsilqbqldx0bV8bwN3SN3yZUBoADVpqMmObLTCBTaxMLpEj6kSlK1WqcrrJcWV5LVaqQKrVZA8FUY64r9QFo18fvHkql0hnrbls3aVWKJRwyU5bB4bMrKqoyRoKfJDA9akoXq8cKgIHBJLT27CB+sRYgALQaZVn1sfekUagH+FDxTKPbNMUHVQHBfnvEIGyyVGOM4rjup4qhXoaHZxvetqIiqih+m4NSKi0GgOGOrTKjYar1Do2LYiYmgGD4PhAA */
      id: "bookingBar",
      initial: "idle",
      predictableActionArguments: true,
      context: initialContext,
      states: {
        idle: {
          on: {
            EDIT: { target: "editing" },
            EMPTY_SUBMIT: { target: "idle", actions: ["hasError"] },
          },
          onEntry: ["getContext"],
        },
        editing: {
          on: {
            SET_LOCATION: {
              actions: ["assignLocation", "resetAccommodation", "getAvailability"],
            },
            SET_ACCOMMODATION: {
              actions: ["assignAccommodation", "getAvailability"],
            },
            RESET_ACCOMMODATION: {
              actions: ["resetAccommodation"],
            },
            SET_DATE: {
              actions: ["assignDate", "getAvailability"],
            },
            VALIDATE: {
              actions: ["hasError"],
            },
            SUBMIT: {
              actions: ["postBooking"],
              cond: "formIsCompleted",
            },
          },
        },
      },
    },
    {
      actions: {
        getAvailability: (context) => {
          const buttonLink = document.querySelector(".js-booking-bar-submit-anchor");
          const dataIsMissing = !context.location;

          if (dataIsMissing) {
            buttonLink.removeAttribute("href");
            return;
          }

          buttonLink.target = "_blank";

          // const SHRCookieConsent = window.shr.utils.getCookie("cookieyes-consent");

          let requestUrl = "/umbraco/api/Availability/GetAvailabilityBookUrl";

          requestUrl += `?companyId=${
            context.location 
              ? context.location.destinationCode
                ? `${context.location.companyId}&destinationCode=${context.location.destinationCode}` 
                : `${context.location.companyId}` 
              : ""
          }`;
          requestUrl += `&propertyId=${context.accommodation?.id ? context.accommodation.id : ""}`;
          requestUrl += `&checkIn=${context.date?.from}`;
          requestUrl += `&checkOut=${context.date?.to}`;
          requestUrl += `&culture=${context.culture}`;
          requestUrl += `&consentAccepted=true`;

          // if (SHRCookieConsent) {
          //   const SHRCookieConsentValues = SHRCookieConsent.split(",");
          //   SHRCookieConsentValues.forEach((value) => {
          //     const val = value.split(":");
          //     if (val[0] === "consent") {
          //       // const consent = val[1] === "yes" ?? false;
          //       requestUrl += `&consentAccepted=true`;
          //     }
          //   });
          // }

          fetch(requestUrl)
            .then((response) => response.json())
            .then((data) => {
              if (data && data.url) {
                buttonLink.setAttribute("href", data.url);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        },
        postBooking: (context) => {
          // eslint-disable-next-line no-console
          // console.log("postBooking", context);
          // Post location, accommodation, date
          // eslint-disable-next-line no-console
          // let requestUrl = "/umbraco/api/Availability/GetAvailabilityBookUrl";
          // requestUrl += `?companyId=${
          //   context.location ? `${context.location.companyId}&destinationCode=${context.location.destinationCode}` : ""
          // }`;
          // requestUrl += `&propertyId=${context.accommodation?.id ? context.accommodation.id : ""}`;
          // requestUrl += `&checkIn=${context.date?.from}`;
          // requestUrl += `&checkOut=${context.date?.to}`;
          //
          // fetch(requestUrl)
          //   .then((response) => response.json())
          //   .then((data) => {
          //     if (data && data.url) {
          //       window.open(data.url, "_blank");
          //     }
          //   })
          //   .catch((error) => {
          //     console.log(error);
          //   });
        },
        assignLocation: assign({
          location: (context, event) => event.location,
        }),
        assignAccommodation: assign({
          accommodation: (context, event) => event.accommodation,
          location: (context, event) => {
            const selectedAccommodation = event.accommodation;
            const data = context.accommodationsData;

            const accommodationData = data.find((accommodation) => accommodation.id === selectedAccommodation.id);
            const { location } = accommodationData;
            return location;
          },
        }),
        assignDate: assign({
          date: (context, event) => event.date,
        }),
        resetAccommodation: assign({
          accommodation: null,
        }),
        hasError: assign({
          errorMessage: (context) => {
            if (!context?.location?.companyId) {
              return ["location"];
            }
            if (!context?.date?.from || !context?.date?.to) {
              return ["date"];
            }
            return null;
          },
        }),
        getContext: (context, event) => {
          // eslint-disable-next-line no-console
          // console.log("getContext", context, event);
        },
      },
      guards: {
        formIsCompleted: (context) => context.location?.companyId && context.accommodation?.id && context.date?.from && context.date?.to,
      },
    },
  );

  return bookingBarMachine;
}

export default createBookingBarMachine;
